import { toStoreCouponsLink, toStoreOffersLink } from 'lib/links';

import APP from 'constants/app';

const BLACK_FRIDAY_COMMERCIAL_SCHEDULE = [
  // FAQ-BANNER
  {
    id: 'kabum-faq-banner',
    name: 'Kabum',
    storeSlug: 'kabum',
    startDate: '2025-10-06',
    endDate: '2025-10-19',
    url: toStoreOffersLink('kabum'),
    type: 'FAQ',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-kabum-faq-desktop-2.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-kabum-faq-mobile-2.jpg`,
    },
  },
  {
    id: 'casas-bahia-faq-banner',
    name: 'Casas Bahia',
    storeSlug: 'casas-bahia',
    startDate: '2025-10-06',
    endDate: '2025-10-19',
    url: toStoreOffersLink('casas-bahia'),
    type: 'FAQ',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-casas-bahia-faq-desktop-2.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-casas-bahia-faq-mobile-2.jpg`,
    },
  },
  {
    id: 'magalu-faq-banner',
    name: 'Magalu',
    storeSlug: 'magazine-luiza',
    startDate: '2025-09-06',
    endDate: '2025-12-19',
    url: toStoreOffersLink('magazine-luiza'),
    type: 'FAQ',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-magalu-faq-desktop-2.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-magalu-faq-mobile-2.jpg`,
    },
  },
  {
    id: 'mercado-livre-faq-banner',
    name: 'Mercado Livre',
    storeSlug: 'mercado-livre',
    startDate: '2025-10-20',
    endDate: '2025-11-02',
    url: toStoreOffersLink('mercado-livre'),
    type: 'FAQ',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-mercado-livre-faq-desktop-2.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-mercado-livre-faq-mobile-2.jpg`,
    },
  },
  {
    id: 'magalu-faq-banner-2',
    name: 'Magalu',
    storeSlug: 'magazine-luiza',
    startDate: '2025-10-20',
    endDate: '2025-10-26',
    url: toStoreOffersLink('magazine-luiza'),
    type: 'FAQ',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-magalu-faq-desktop.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-magalu-faq-mobile.jpg`,
    },
  },
  {
    id: 'aliexpress-faq-banner',
    name: 'Aliexpress',
    storeSlug: 'aliexpress',
    startDate: '2025-10-27',
    endDate: '2025-11-02',
    url: toStoreOffersLink('aliexpress'),
    type: 'FAQ',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-aliexpress-faq-desktop.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-aliexpress-faq-mobile.jpg`,
    },
  },
  {
    id: 'amazon-faq-banner',
    name: 'Amazon',
    storeSlug: 'amazon',
    startDate: '2025-10-20',
    endDate: '2025-10-26',
    url: toStoreOffersLink('amazon'),
    type: 'FAQ',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-amazon-faq-desktop-2.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-amazon-faq-mobile-2.jpg`,
    },
  },
  {
    id: 'acer-faq-banner',
    name: 'Acer',
    storeSlug: 'acer',
    startDate: '2025-10-27',
    endDate: '2025-11-02',
    url: toStoreOffersLink('acer'),
    type: 'FAQ',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-acer-faq-desktop-3.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-acer-faq-mobile-3.jpg`,
    },
  },

  // OFERTAS-BANNER
  {
    id: 'amazon-ofertas-banner',
    name: 'Amazon',
    storeSlug: 'amazon',
    startDate: '2025-09-15',
    endDate: '2025-09-17',
    url: toStoreOffersLink('amazon'),
    type: 'OFFERS_BANNER',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-offer-amazon-desk.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-offer-amazon-mobile.jpg`,
    },
  },
  {
    id: 'mercado-livre-ofertas-banner',
    name: 'Mercado Livre',
    storeSlug: 'mercado-livre',
    startDate: '2025-09-18',
    endDate: '2025-09-28',
    url: toStoreOffersLink('mercado-livre'),
    type: 'OFFERS_BANNER',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-offer-ml-desk.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-offer-ml-mobile.jpg`,
    },
  },
  {
    id: 'casas-bahia-ofertas-banner',
    name: 'Casas Bahia',
    storeSlug: 'casas-bahia',
    startDate: '2025-09-29',
    endDate: '2025-10-05',
    url: toStoreOffersLink('casas-bahia'),
    type: 'OFFERS_BANNER',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-offer-casas-bahia-desk.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-offer-casas-bahia-mobile.jpg`,
    },
  },
  {
    id: 'acer-ofertas-banner',
    name: 'Acer',
    storeSlug: 'acer',
    startDate: '2025-10-06',
    endDate: '2025-10-19',
    url: toStoreOffersLink('acer'),
    type: 'OFFERS_BANNER',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-offer-acer-desk.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-offer-acer-mobile.jpg`,
    },
  },
  {
    id: 'nike-ofertas-banner',
    name: 'Nike',
    storeSlug: 'nike',
    startDate: '2025-10-20',
    endDate: '2025-10-26',
    url: toStoreOffersLink('nike'),
    type: 'OFFERS_BANNER',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-offer-nike-desk.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-offer-nike-mobile.jpg`,
    },
  },
  {
    id: 'casas-bahia-ofertas-banner-2',
    name: 'Casas Bahia',
    storeSlug: 'casas-bahia',
    startDate: '2025-10-27',
    endDate: '2025-11-02',
    url: toStoreOffersLink('casas-bahia'),
    type: 'OFFERS_BANNER',
    images: {
      desktop: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-offer-casas-bahia-desk.jpg`,
      mobile: `${APP.LOCAL_IMAGE_PATH}/features/my-black-friday/placements/my-bf-offer-casas-bahia-mobile.jpg`,
    },
  },

  // OFERTAS-SELECAO
  {
    id: 'mercado-livre-ofertas-selecao-1',
    name: 'Mercado Livre',
    storeSlug: 'mercado-livre',
    startDate: '2025-09-15',
    endDate: '2025-09-21',
    url: toStoreOffersLink('mercado-livre'),
    type: 'OFFERS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'amazon-ofertas-selecao-1',
    name: 'Amazon',
    storeSlug: 'amazon',
    startDate: '2025-09-22',
    endDate: '2025-09-28',
    url: toStoreOffersLink('amazon'),
    type: 'OFFERS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'magalu-ofertas-selecao-1',
    name: 'Magalu',
    storeSlug: 'magazine-luiza',
    startDate: '2025-09-29',
    endDate: '2025-10-05',
    url: toStoreOffersLink('magazine-luiza'),
    type: 'OFFERS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'aliexpress-ofertas-selecao-1',
    name: 'AliExpress',
    storeSlug: 'aliexpress',
    startDate: '2025-11-03',
    endDate: '2025-11-09',
    url: toStoreOffersLink('aliexpress'),
    type: 'OFFERS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'samsung-ofertas-selecao-1',
    name: 'Samsung',
    storeSlug: 'samsung',
    startDate: '2025-10-06',
    endDate: '2025-10-19',
    url: toStoreOffersLink('samsung'),
    type: 'OFFERS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'amazon-ofertas-selecao-2',
    name: 'Amazon',
    storeSlug: 'amazon',
    startDate: '2025-10-13',
    endDate: '2025-10-19',
    url: toStoreOffersLink('amazon'),
    type: 'OFFERS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'mercado-livre-ofertas-selecao-3',
    name: 'Mercado Livre',
    storeSlug: 'mercado-livre',
    startDate: '2025-11-10',
    endDate: '2025-11-16',
    url: toStoreOffersLink('mercado-livre'),
    type: 'OFFERS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'amazon-ofertas-selecao-3',
    name: 'Amazon',
    storeSlug: 'amazon',
    startDate: '2025-11-17',
    endDate: '2025-11-23',
    url: toStoreOffersLink('amazon'),
    type: 'OFFERS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'magalu-ofertas-selecao-3',
    name: 'Magalu',
    storeSlug: 'magazine-luiza',
    startDate: '2025-11-24',
    endDate: '2025-11-30',
    url: toStoreOffersLink('magazine-luiza'),
    type: 'OFFERS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'aliexpress-ofertas-selecao-3',
    name: 'AliExpress',
    storeSlug: 'aliexpress',
    startDate: '2025-12-01',
    endDate: '2025-12-07',
    url: toStoreOffersLink('aliexpress'),
    type: 'OFFERS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'futfanatics-ofertas-selecao-3',
    name: 'Fut Fanatics',
    storeSlug: 'futfanatics',
    startDate: '2025-10-20',
    endDate: '2025-11-02',
    url: toStoreOffersLink('futfanatics'),
    type: 'OFFERS',
    images: {
      desktop: null,
      mobile: null,
    },
  },

  // CUPONS-SELECAO
  {
    id: 'mercado-livre-cupons-selecao-1',
    name: 'Mercado Livre',
    storeSlug: 'mercado-livre',
    startDate: '2025-09-29',
    endDate: '2025-10-03',
    url: toStoreCouponsLink('mercado-livre'),
    type: 'COUPONS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'amazon-cupons-selecao-1',
    name: 'Amazon',
    storeSlug: 'amazon',
    startDate: '2025-11-10',
    endDate: '2025-11-16',
    url: toStoreCouponsLink('amazon'),
    type: 'COUPONS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'magalu-cupons-selecao-1',
    name: 'Magalu',
    storeSlug: 'magazine-luiza',
    startDate: '2025-10-20',
    endDate: '2025-11-02',
    url: toStoreCouponsLink('magazine-luiza'),
    type: 'COUPONS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'aliexpress-cupons-selecao-1',
    name: 'AliExpress',
    storeSlug: 'aliexpress',
    startDate: '2025-09-15',
    endDate: '2025-09-19',
    url: toStoreCouponsLink('aliexpress'),
    type: 'COUPONS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'aliexpress-cupons-selecao-3',
    name: 'AliExpress',
    storeSlug: 'aliexpress',
    startDate: '2025-11-24',
    endDate: '2025-11-30',
    url: toStoreCouponsLink('aliexpress'),
    type: 'COUPONS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'kabum-cupons-selecao-1',
    name: 'KaBum!',
    storeSlug: 'kabum',
    startDate: '2025-12-01',
    endDate: '2025-12-07',
    url: toStoreCouponsLink('kabum'),
    type: 'COUPONS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'casas-bahia-cupons-selecao-1',
    name: 'Casas Bahia',
    storeSlug: 'casas-bahia',
    startDate: '2025-09-22',
    endDate: '2025-09-26',
    url: toStoreCouponsLink('casas-bahia'),
    type: 'COUPONS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'samsung-cupons-selecao-1',
    name: 'Samsung',
    storeSlug: 'samsung',
    startDate: '2025-12-15',
    endDate: '2025-12-21',
    url: toStoreCouponsLink('samsung'),
    type: 'COUPONS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'mercado-livre-cupons-selecao-2',
    name: 'Mercado Livre',
    storeSlug: 'mercado-livre',
    startDate: '2025-11-03',
    endDate: '2025-11-09',
    url: toStoreCouponsLink('mercado-livre'),
    type: 'COUPONS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'magalu-cupons-selecao-2',
    name: 'Magalu',
    storeSlug: 'magazine-luiza',
    startDate: '2025-11-17',
    endDate: '2025-11-23',
    url: toStoreCouponsLink('magazine-luiza'),
    type: 'COUPONS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'aliexpress-cupons-selecao-2',
    name: 'AliExpress',
    storeSlug: 'aliexpress',
    startDate: '2025-10-06',
    endDate: '2025-10-19',
    url: toStoreCouponsLink('aliexpress'),
    type: 'COUPONS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'casas-bahia-cupons-selecao-3',
    name: 'Casas Bahia',
    storeSlug: 'casas-bahia',
    startDate: '2025-12-08',
    endDate: '2025-12-14',
    url: toStoreCouponsLink('casas-bahia'),
    type: 'COUPONS',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  // PARTNER-APP
  {
    id: 'mercado-livre-partner-app-1',
    name: 'Mercado Livre',
    storeSlug: 'mercado-livre',
    startDate: '2025-09-15',
    endDate: '2025-09-21',
    url: 'https://www.mercadolivre.com.br/l/baixe-o-app',
    type: 'PARTNER_APP',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'amazon-partner-app-1',
    name: 'Amazon',
    storeSlug: 'amazon',
    startDate: '2025-09-22',
    endDate: '2025-09-28',
    url: 'https://www.amazon.com.br/b?node=11437312011',
    type: 'PARTNER_APP',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'magalu-partner-app-1',
    name: 'Magalu',
    storeSlug: 'magazine-luiza',
    startDate: '2025-09-29',
    endDate: '2025-10-05',
    url: 'https://especiais.magazineluiza.com.br/superapp-magalu/',
    type: 'PARTNER_APP',
    images: {
      desktop: null,
      mobile: null,
    },
  },
  {
    id: 'mercado-livre-partner-app-2',
    name: 'Mercado Livre',
    storeSlug: 'mercado-livre',
    startDate: '2025-10-06',
    endDate: '2025-11-02',
    url: 'https://www.mercadolivre.com.br/l/baixe-o-app',
    type: 'PARTNER_APP',
    images: {
      desktop: null,
      mobile: null,
    },
  },
];

const activeCampaigns = () => {
  const now = Date.now();

  return BLACK_FRIDAY_COMMERCIAL_SCHEDULE.filter((campaign) => {
    const startDate = new Date(campaign.startDate).getTime();
    const endDateInclusive = new Date(campaign.endDate);
    endDateInclusive.setDate(endDateInclusive.getDate() + 1);

    const endDate = endDateInclusive.getTime();

    return now >= startDate && now <= endDate;
  });
};

const getCampaignByType = (type) =>
  activeCampaigns().find((campaign) => campaign.type === type) ?? null;

const useMyBlackFridayScheduler = () => {
  return {
    activeCampaigns,
    getCampaignByType,
  };
};

export default useMyBlackFridayScheduler;
